// extracted by mini-css-extract-plugin
module.exports = {"sharebox":"sharePanel-module--sharebox--15AJZ","shareboxsocial":"sharePanel-module--shareboxsocial--2IwEu","shareboxtitle":"sharePanel-module--shareboxtitle--3OPVa"};